export enum PosType {
    Mobile,
    Web
}


// WEBPACK FOOTER //
// ./src/app/models/PosType.ts